import * as t from "io-ts";

import { BasketLineAPIURL } from "./nominals";
import { Price } from "./prices";

const ShippingMethodType = t.keyof({
    "small-package": null,
    "freight": null,
});

const ShippingMethodLine = t.readonly(
    t.type({
        charge_order: t.string,
        charge_total: t.string,
        method: t.readonly(
            t.type({
                id: t.number,
                name: t.string,
                description: t.string,
                type: ShippingMethodType,
            }),
        ),
        line_url: BasketLineAPIURL,
        charge_line: t.string,
    }),
);
export type IShippingMethodLine = t.TypeOf<typeof ShippingMethodLine>;

const ShippingMethod = t.readonly(
    t.type({
        code: t.string,
        name: t.string,
        selected: t.boolean,
        price: Price,
        price_before_discount: Price,
        lines: t.readonlyArray(ShippingMethodLine),
    }),
);
export type IShippingMethod = t.TypeOf<typeof ShippingMethod>;
export const ShippingMethods = t.readonlyArray(ShippingMethod);

const ProductShippingMethod = t.readonly(
    t.type({
        name: t.string,
        description: t.string,
        type: ShippingMethodType,
    }),
);
export type IProductShippingMethod = t.TypeOf<typeof ProductShippingMethod>;
export const ProductShippingMethods = t.readonlyArray(ProductShippingMethod);
